import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import CommentItem from './CommentItem';
import StatusItem from './StatusItem';
import EventUploadItem from './EventUploadItem';
import styles from './styles';

const getItem = (type) => {
  switch (type) {
    case 'eventStatus':
      return StatusItem;
    case 'eventComplete': // Specific to event activity
      return StatusItem;
    case 'eventStart': // Specific to event activity
      return StatusItem;
    case 'comment':
      return CommentItem;
    case 'eventUpload':
      return EventUploadItem;
    default:
      return () => <div />;
  }
};

export class HistoryItemComponent extends React.Component {
  render() {
    const { item } = this.props;

    const Item = getItem(item.type);

    return (
      <Item {...this.props} />
    );
  }
}

HistoryItemComponent.propTypes = { item: PropTypes.object };

HistoryItemComponent.defaultProps = { item: {} };

export default withStyles(styles)(HistoryItemComponent);
